import { useTranslation } from 'react-i18next';

import type { Dispatch, SetStateAction } from 'react';

import RouteAccordionContent from '@/components/Incidents/incident-filters/route-accordion-content';
import StationAccordionContent from '@/components/Incidents/incident-filters/station-accordion-content';
import CustomAccordion from '@/components/ui/custom-accordion';
import { ScrollArea } from '@/components/ui/scroll-area';

const FILTER = {
  routes: 'Routes',
  stations: 'Stations',
};

interface IncidentFiltersProps {
  selectedRoutes: { journeyId: string; lineNumber: string }[];
  setSelectedRoutes: Dispatch<SetStateAction<{ journeyId: string; lineNumber: string }[]>>;
  selectedStations: string[];
  setSelectedStations: Dispatch<SetStateAction<string[]>>;
}

const IncidentFilters = ({
  selectedRoutes,
  setSelectedRoutes,
  selectedStations,
  setSelectedStations,
}: IncidentFiltersProps) => {
  const { t } = useTranslation();

  const accordionItems = [
    {
      value: FILTER.routes,
      title: t('filters.by_routes'),
      content: (
        <RouteAccordionContent
          selectedRoutes={selectedRoutes}
          setSelectedRoutes={setSelectedRoutes}
        />
      ),
    },
    {
      value: FILTER.stations,
      title: t('filters.by_station'),
      content: (
        <StationAccordionContent
          selectedStations={selectedStations}
          setSelectedStations={setSelectedStations}
        />
      ),
    },
  ];

  return (
    <ScrollArea className="h-full">
      <div className="px-4">
        <CustomAccordion type="multiple" items={accordionItems} />
      </div>
    </ScrollArea>
  );
};

export default IncidentFilters;
